/**
 * 비디오를 어디서 띄워줄 지를 의미하는 값. Web: 웹뷰, App: 앱, None: 재생지원X
 * Web은 모든 인라인 동영상, 풀스크린 동영상을 웹뷰로 시청 가능
 * App은 인라인 동영상은 재생 불가. 풀스크린 동영상은 앱을 통해 시청 가능
 * None은 인라인 동영상, 풀스크린 동영상 모두 재생 불가
 */
export enum VideoPlayType {
  Web = 'web',
  App = 'app',
  None = 'none',
}
